const ENV = process.env.NODE_ENV || 'development';

const configs = {
  development: {
    API_BASE: 'https://julia-x7xy.onrender.com/api',
  },
  staging: {
    API_BASE: 'https://staging-api.seusite.com/api',
  },
  production: {
    API_BASE: 'https://api.seusite.com/api',
  },
};

export default configs[ENV];
